<template>
  <div id="companyPublic">
    <div class="btnBoxs">
      <div style="display: flex;">
        <div>
        <span style="font-size: 0.75rem;">排&nbsp;&nbsp;&nbsp;序:</span>
      <el-select v-model="field" filterable placeholder="请选择" style="width: 300px ;" size='mini'>
       <!--  @change="pagefeed()" -->
        <el-option v-for="(item,index) in patternAll" :key="index" :label="item.label" :value="item.label">
        </el-option>
      </el-select>
      </div>
      <div style="margin: 0 0 0 60px;">
        <span style="font-size: 0.75rem;">关键字:</span>
      <el-input v-model="keywords" autocomplete="off" style="width: 200px ;" size='mini'>
      </el-input>
      </div>
      <div class="btn">
        <el-button type="primary" size='mini'  icon="el-icon-search"   @click="pagefeed(1)">搜 索</el-button>
        <el-button  size='mini'  icon="el-icon-circle-close" @click="keywords = ''; field = ''">清 空</el-button>
      </div>
      </div>

    </div>
    <el-table :data="showData" border style="width: auto" :height="TableHeight" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column type="index" label="行号" width="55" :index="indexMethod">
      </el-table-column>
      <el-table-column prop="salesman" label="原销售员" align="center" width='80'>
      </el-table-column>
      <el-table-column prop="company" label="客户公司" align="center" show-overflow-tooltip width="150">
      </el-table-column>
      <el-table-column prop="name" label="客户姓名" align="center">
      </el-table-column>
      <el-table-column prop="tel" label="客户电话" align="center" show-overflow-tooltip width="150">
      </el-table-column>
      <el-table-column prop="qqnumber" label="客户QQ" align="center">
      </el-table-column>
      <el-table-column prop="wxnumber" label="客户微信" align="center">
      </el-table-column>
      <el-table-column prop="remarks" label="客户备注" show-overflow-tooltip width="180">
      </el-table-column>
      <el-table-column prop="result" label="最近联系记录">
      </el-table-column>
      <el-table-column prop="firsttime" label="录入时间" width="200">
      </el-table-column>
      <el-table-column prop="counter" label="联系次数" width='80'>
      </el-table-column>
      <el-table-column prop="lasttime" label="最近联系时间" width="200">
      </el-table-column>
      <el-table-column prop="status" label="状态" width='80'>
      </el-table-column>
    </el-table>

    <div class="block">
      <!-- 分页 -->
      <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
        :page-size="pageSize" layout="prev, pager, next, slot, jumper" :total="currentPage4">
        <span slot style="width: 40px;color: dimgrey">
          <label><input name="Fruit" type="checkbox" value="" v-model="checked" @change='all' />显示全部</label>
        </span>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  customuser,
  customUsershow,
  userdata,
  custompublicpool,
} from '../../../static/API/API.js'
export default {
  components: { //动态组件

  },
  data() {
    return {
      // 分页
      currentPage4: 0,
      currentPage1: 1,
      currentPage: 10,
      pageSize: 1,
      keywords: '',
      // 配搜索条件
      field: '',
      patternAll: [
          {
            label: '客户公司'
          },
          {
            label: '销售员'
          }
        ],
      showData: [],
      dlogTableVisible: false,
      PIMS: [],
      department: '', //获取部门
      //图片储存
      fileList: [],
      checked: false,
      TableHeight:490,
      loading:false
    }
  },
  mounted() { //mounted是vue中的一个钩子函数，一般在初始化页面完成后，再对dom节点进行相关操作
    this.department = sessionStorage.getItem('department')
    this.PIM()
    this.getHeight()
  },
  created () {
    window.addEventListener('resize', this.getHeight)
  },
    destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: { //函数
    getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.TableHeight = windowHeight - 300;//数值"140"根据需要调整
    })
      },
    // 改变当前所在页
    currentChangeHandle(val) {
      this.currentPage1 = val
      this.pagefeed()
    },
    // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
    all() {
      if (this.checked) {
        this.currentPage = 'all'
        this.pagefeed()
      } else {
        this.currentPage = 10
        this.pagefeed()
      }
    },
    PIM() {
      let params = new URLSearchParams()
      params.append('ope_type', '公司员工')
      params.append('page_size', 'all')
      params.append('companyid', sessionStorage.getItem('companyid'))
      params.append('user_id', sessionStorage.getItem('user_id'))
      this.$axios.post(userdata, params).then(async res => {
        this.PIMS = res.data
        console.log(res.data)
        await this.pagefeed()
      })
    },
    //保存信息
    onPreserve() {
      let params = new URLSearchParams();
      params.append('ope_type', '修改')
      this.upForm.CRM_CUSTOMER_USER_id_PK = this.upForm.id
      delete this.upForm.id; //删除当前键名为id的属性
      delete this.upForm.company; //删除当前键名为id的属性
      delete this.upForm.salesman; //删除当前键名为id的属性
      params.append('datas', JSON.stringify(this.upForm))
      this.$axios.post(customuser, params).then(res => {
        if (res.data == '修改成功!') {
          this.$alert('信息修改成功！', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `信息已修改！`,
                duration: 1000,
            showClose: true,
              });
              this.dlogTableVisible = false
              this.pagefeed()
            }
          });
        } else {
          this.$alert('信息修改失败！', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `信息修改失败请核对好客户信息！`,
                duration: 1000,
            showClose: true,
              });
              this.pagefeed()
            }
          });
        }
      })
    },
    handleClose(done) {
      this.$confirm('确定要离开本页面么？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '离开',
        cancelButtonText: '取消'
      })
        .then(_ => {
          this.dlogTableVisible = false;
        })
        .catch(_ => {
          this.$message({
            type: 'info',
            message: '已取消',
            duration: 1000,
            showClose: true,
          });
        });
    },
    //编辑
    handleClick(row) {
      console.log(row)
      this.dlogTableVisible = true
    },
    //渲染数据
    pagefeed(e) {
      this.loading = true
      let params = new URLSearchParams()
      params.append('keyword', this.keywords);
      if (e) {
        params.append('page_number', 1)
      } else {
        params.append('page_number', this.currentPage1)
      }
      params.append('sort', this.field)
      if(this.field =='客户公司' || this.field =='销售员'){
        params.append('field', this.field)
      }
      params.append('page_size', this.currentPage)
      params.append('department', this.department)
      params.append('companyid', sessionStorage.getItem('companyid'))
      this.$axios.post(custompublicpool, params).then(res => {
        console.log(res.data)
        this.currentPage4 = res.data[0]['PageNums'];
        this.showData = res.data[0]['pagedata']
        setTimeout(()=>{
          this.loading = false
        },300)
      })
    },
    indexMethod(index) {
      return index + 1;
    },
  },
  computed: { //计算属性

  },
  watch: { //监测Vue实例上的数据变动

  }
}
</script>

<style scoped>
.btnBoxs{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.btn{
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/public/companyPublic.vue